import * as React from 'react';
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import Image from '../../components/Image';
import { IssueType } from '../../services/stickerColor';
import { useNavigate } from 'react-router-dom';

const IssuesList = ({ issues, title }) => {
    const navigate = useNavigate();

    if (!issues || issues.length === 0) {
        return null;
    }

    return (
        <>
            <Typography
                variant='body2'
                fontWeight='500'
                textTransform='uppercase'
                color='text.secondary'
                my={2}>
                {title}
            </Typography>
            {issues.map((issue, i) => (
                <Box key={i}>
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            pb: 1,
                            mt: 0.3,
                            cursor: 'pointer',
                            borderRadius: '4px',
                            '&:hover': {
                                backgroundColor: 'custom.cardHover',
                            },
                        }}
                        display='flex'
                        alignItems='center'
                        onClick={() =>
                            navigate(
                                `/view-project`
                            )
                        }
                        >
                        <Grid item xs sx={{ minWidth: 0 }}>
                            <Box display='flex' alignItems='flex-start'>
                                <Tooltip title={issue.issueType} placement='top'>
                                    <Box
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            mr: 1,
                                            cursor: 'pointer',
                                        }}>
                                        <Image name={IssueType[issue.issueType]} />
                                    </Box>
                                </Tooltip>
                                <Box
                                    sx={{
                                        cursor: 'pointer',
                                        display: 'flex',
                                        flexFlow: 'column nowrap',
                                        position: 'relative',
                                        minHeight: '100%',
                                        minWidth: '0',
                                    }}>
                                    <Typography
                                        variant='body2'
                                        color='text.tertiary'
                                        fontWeight='bold'
                                        lineHeight='1rem'
                                        sx={{
                                            maxWidth: '300px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            py: 0,
                                            m: 0,
                                        }}>
                                        {issue.issueTitle}
                                    </Typography>
                                    <Typography variant='caption' color='text.secondary'>
                                        {issue.issueKey} - {issue.projectName}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            ))}
        </>
    );
};

const AssignedList = ({ issues }) => {
    if (!issues) {
        return (
            <Box>
                <Typography
                    variant='body2'
                    fontWeight='500'
                    color='text.secondary'
                    textAlign='center'
                    my={2}>
                    No assigned issues
                </Typography>
            </Box>
        );
    }

    return (
        <>
            <IssuesList issues={issues.toDo} title='To Do' />
            <IssuesList issues={issues.inProgress} title='In Progress' />
        </>
    );
};

export default AssignedList;
